export default __webpack_public_path__ + "static/media/word.635c8e1b.svg";